import { useState } from 'react';
import {
  AuthPanel,
  SignInForm,
  SignInFormValues,
} from '@nbirl/nbi-common-ui-libs';

import { TextLink } from '../../../shared/components';
import { PATHS } from '../../../shared/constants';
import { useAuth } from '../../../shared/context';
import { useErrorToast } from '../../../shared/hooks';

export const SignIn = () => {
  const { signIn } = useAuth();
  const [isPending, setIsPending] = useState(false);
  const { showErrorToast } = useErrorToast();

  const handleSubmit = async ({ username, password }: SignInFormValues) => {
    try {
      setIsPending(true);
      await signIn(username, password);
    } catch (error: any) {
      setIsPending(false);
      showErrorToast(error);
    }
  };

  return (
    <div className="space-y-2">
      <AuthPanel>
        <SignInForm
          isPending={isPending}
          onSubmit={handleSubmit}
          secondaryActionElement={
            <TextLink to={PATHS.ForgotPassword}>Forgot Password</TextLink>
          }
        />
      </AuthPanel>
      <div className="mx-auto max-w-xl text-sm pl-2">{`NBI Secure Portal (v ${process.env.REACT_APP_VERSION})`}</div>
    </div>
  );
};
